import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiBook } from 'react-icons/fi';
import BlogCard from './BlogCard';
import { blogsAPI } from '../../services/blogApi';
import { BlogListItem } from '../../types';

const LatestBlogsSection: React.FC = () => {
  const [blogs, setBlogs] = useState<BlogListItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchLatest = async () => {
      try {
        const data = await blogsAPI.list(1, 3);
        if (isMounted) {
          setBlogs(data.data);
        }
      } catch {
        if (isMounted) {
          setBlogs([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchLatest();
    return () => {
      isMounted = false;
    };
  }, []);

  if (!loading && blogs.length === 0) {
    return null;
  }

  return (
    <section className="mb-24 px-2">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full mb-3 bg-purple-50 dark:bg-purple-900/20 text-purple-600 dark:text-purple-300 text-sm font-semibold">
            <FiBook size={14} />
            Travel Blog
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
            Latest Articles
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mt-2 max-w-xl">
            Visa guides, travel tips, and passport advice from our experts.
          </p>
        </div>
        <Link
          to="/blog"
          className="inline-flex items-center gap-2 text-blue-600 dark:text-blue-400 font-semibold hover:gap-3 transition-all"
        >
          View all articles <FiArrowRight />
        </Link>
      </div>

      {loading ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3].map((item) => (
            <div
              key={item}
              className="h-80 rounded-2xl bg-gray-200 dark:bg-slate-700 animate-pulse"
            />
          ))}
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogs.map((blog) => (
            <BlogCard key={blog.id} blog={blog} />
          ))}
        </div>
      )}
    </section>
  );
};

export default LatestBlogsSection;
